import { useDelete } from '@refinedev/core';

export function useDeleteFactFind() {
  const { mutateAsync, error, isLoading, reset } = useDelete();

  const deleteFactFind = async (clientId: string, reportId: string) => {
    return mutateAsync({
      resource: `clients/${clientId}/fact-finds`,
      id: reportId,
    });
  };

  return {
    deleteFactFind,
    error,
    isLoading,
    reset,
  };
}
